export var Share;
(function (Share) {
    let edgeRegistry;
    let nodeRegistry;
    function exist(name, isNode) {
        return isNode ? edgeRegistry.exist(name) : nodeRegistry.exist(name);
    }
    Share.exist = exist;
    function setEdgeRegistry(registry) {
        edgeRegistry = registry;
    }
    Share.setEdgeRegistry = setEdgeRegistry;
    function setNodeRegistry(registry) {
        nodeRegistry = registry;
    }
    Share.setNodeRegistry = setNodeRegistry;
})(Share || (Share = {}));
//# sourceMappingURL=registry.js.map